<template>
  <div class="input-type-dropdown-select" v-on:blur="open = false" tabindex="0">
    <div
      class="select-menu-button"
      :class="{ 'button-open': open, disabled: disabled }"
      color="#ffffff"
      @click="openDropdown"
    >
      <div class="button-inner">
        <span class="menu-title">{{ getSelectedOptionsText }}</span>
        <div class="icon-area">
          <feather-icon
            v-if="viewButton"
            class="view-icon"
            icon="EyeIcon"
            svgClasses="h-6 w-6"
            @click.stop="onViewButtonClick"
          />
          <feather-icon
            class="arrow-icon"
            :class="{ open: open }"
            icon="ChevronDownIcon"
            svgClasses="h-4 w-4"
          />
        </div>
      </div>
    </div>
    <transition name="fade">
      <template>
        <div class="select-item-container" v-if="open">
          <div
            class="select-item"
            @click="setValue(enterpriseOption.value)"
            v-for="(enterpriseOption, index) in selectOptions"
            :key="index"
          >
            <feather-icon
              v-if="enterpriseOption.featherIconName"
              class="custom-feather-icon"
              :icon="enterpriseOption.featherIconName"
              svgClasses="h-4 w-4"
            />
            {{ enterpriseOption.text }}
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    onSelect: {
      type: Function,
      required: false,
      default: () => {},
    },
    selectedValue: {
      required: true,
    },
    selectOptions: {
      type: Array,
      required: true,
    },
    viewButton: {
      type: Boolean,
      default: false,
    },
    onViewButtonClick: {
      type: Function,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
      menuButtonLabel: "形式",
    };
  },
  computed: {
    getSelectedOptionsText() {
      const option = this.selectOptions.find(
        item => item.value === this.selectedValue
      );
      if (option) {
        return option.text;
      } else {
        return "";
      }
    },
  },
  methods: {
    openDropdown() {
      if (!this.disabled) {
        this.open = !this.open;
      }
    },
    getSelectedOptionsTextaaa(value) {
      const option = this.selectOptions.find(item => item.value === value);
      if (option) {
        return option.text;
      } else {
        return "";
      }
    },
    setValue(value) {
      this.$emit("update:selectedValue", value);
      this.open = false;

      this.onSelect();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.input-type-dropdown-select {
  position: relative;
  //width: fit-content;
  height: fit-content;
  min-width: 150px;
  //max-width: 300px;
  margin-left: auto;
  user-select: none;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.select-menu-button {
  //margin-top: -10px;
  //min-width: 200px;
  height: 39px;
  border-radius: 6px;
  border: solid 1px #cacaca;
  background: #fff;
  color: #777;
  padding: 8px 13px !important;
  transition: all 300ms 0s ease;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    box-shadow: 0 2px 8px -2px #777;
  }
  &.disabled {
    //pointer-events: none;
    cursor: not-allowed;
    background: #ececec;
    &:hover {
      box-shadow: 0 0 0 0 #777;
    }
  }
}
.button-open {
  border-radius: 4px 4px 0px 0px;
  border-bottom: solid 1px #e0e0e0;
}
.menu-title {
  margin-right: 10px;
}
.anchor-icon,
.settings-icon {
  margin-right: 5px;
  padding-bottom: 2px;
}
.select-item-container {
  position: absolute;
  z-index: 1;
  background: white;
  width: 100%;
  max-height: 340px;
  overflow-y: auto;

  border-radius: 0 0 0.5rem 0.5rem;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
}
.select-item {
  cursor: pointer;
  padding: 8px 13px;
  display: flex;
  .custom-feather-icon {
    margin-right: 12px;
  }
}
.select-item:hover {
  background: $pm-transparent-blue;
  color: $pm-blue;
  transition: 0.2s;
}
.button-inner {
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.arrow-icon {
  margin-left: auto;
  transition: all 300ms 0s ease;
}
.icon-area {
  display: flex;
  .view-icon {
    margin-right: 10px;
    cursor: pointer;
  }
}
.open {
  transform: rotateZ(-180deg);
}
.vs-button-text {
  display: block !important;
}
/*
.disabled {
  //pointer-events: none;
  background: #ececec;
}
*/
</style>
